import React from 'react'
import { Box, Typography } from '@mui/material'
import {
	ComparisonContent,
	FeaturesBlock,
	PriceContent
} from 'Pages/AnalyzersV2/@components/Table/columns/Data/@components/'
import AnalyzerPopover from "Pages/AnalyzersV2/@components/Popover"
import { useCellColors, useCellPopover } from "Pages/AnalyzersV2/@components/Table/columns/Data/@hooks"
import { isEmpty } from "@ui-seeker/utils"
import {
	analyzerFilters,
	openEvolutionModal,
	tableHasMainComparison,
	tableHideDetails
} from "Pages/AnalyzersV2/@signals"

export default function dataColumn(label, evolutionData, { isRating = false, isPosition = false } = {}) {
	return {
		name: label,
		label: label,
		render: value => <RenderDataCell value={value} isRating={isRating} isPosition={isPosition} />
	}
}

function RenderDataCell({ value, isRating, isPosition }) {
	const {
		price_data, price, previous_price, evolutionChange, isCheapestColumn,
		isMoreExpensiveColumn, noResult, evolutionDiff, comparison_type,
		diff_price, name, evolutionFilter, main_name
	} = value

	const { bgColor, borderColor, hoverBorderColor } = useCellColors(isCheapestColumn, isMoreExpensiveColumn)
	const { isOpenPopover, onClosePopover, onOpenPopover } = useCellPopover(noResult)
	const hideDetails = tableHideDetails.value
	const hasValue = !isEmpty(value)
	const clickable = !noResult && hasValue
	// Position answers one question per cell — how this price sits against the main
	// brand — so it always carries the gap and never the previous price, the
	// evolution or the features, whatever the details toggle says.
	const showComparison = isPosition || !hideDetails
	const isCompact = isPosition || hideDetails

	const handleOpenEvolutionModal = ({ currentTarget }) => {
		if (!isRating) return onOpenPopover(currentTarget)

		openEvolutionModal.value = {
			price_data: evolutionFilter,
			filters: analyzerFilters.value,
			tableRows: [price_data]
		}
	}

	return <Box onClick={handleOpenEvolutionModal}
				sx={{
					cursor: clickable ? 'pointer' : 'default',
					display: 'flex', alignItems: 'center', justifyContent: 'center',
					'&:hover': {
						borderColor: hoverBorderColor
					}}}>
		<Box
			sx={{
				border: 2,
				borderColor: borderColor,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				backgroundColor: bgColor,
				// The gap needs a little more room than a bare price, but nowhere near
				// the full detailed cell.
				width: isPosition ? 84 : (hideDetails ? 70 : 130),
				minHeight: isCompact ? undefined : (tableHasMainComparison.value ? 125 : 77)
			}}>
			<Box
				sx={{
					width: isCompact ? '100%' : 110,
					m: isCompact ? 0 : 2
				}}>
				{clickable ? <PriceContent
						prevPrice={previous_price}
						price={price}
						evolutionChange={evolutionChange}
						evolutionDiff={evolutionDiff}
						currency={price_data?.id_master_currency_translation}
						compact={isPosition}
					/>
					: <Typography sx={{ m: isCompact ? 0 : 1.2, textAlign: 'center' }} variant="subtitle1">N/A</Typography>}
				{showComparison && <ComparisonContent
					comparison_type={comparison_type || 'noComparison'}
					diff_price={diff_price}
					name={name}
					mainName={main_name}
					clickable={clickable}
					compact={isPosition}
				/>}

				{!isCompact && <FeaturesBlock cellData={price_data} noResult={noResult} />}
			</Box>
		</Box>
		{isOpenPopover && hasValue && <AnalyzerPopover
			isOpen={isOpenPopover}
			onClose={onClosePopover}
			data={value}
			isRating={isRating}
			hideEvolution={isPosition}
		/>}
	</Box>
}
